import http from "../../http-common";

const get = (data) => http.post("/Product/FilterProduct", data);

const create = (data) => http.post("/Product/InsertUpdateProduct", data);

export default { get, create };
